import React, { useState } from "react";
import BillUploadButton from "./BillUploadButton";
import { ESTIMATE_APPROVAL_ARRAY } from "../utils";
import { userRoles, userStatus } from "../../../../../constants/user";
import { useAppSelector } from "../../../../../redux/store";
import { shallowEqual } from "react-redux";

type Props = {
  patient: any;
  selectedStatus: string;
  isStablePatient: boolean;
  estimateApprovalDocs: [
    { label: string; path: string }[],
    React.Dispatch<React.SetStateAction<{ label: string; path: string }[]>>
  ];
};

const EstimateApproval = (props: Props) => {
  const { patient, isStablePatient, selectedStatus } = props;

  const [estimateApprovalDocs, setEstimateApprovalDocs] =
    props.estimateApprovalDocs;

  const { role } = useAppSelector((state) => {
    return state.auth.profileData.user;
  }, shallowEqual);

  const handleUpload = (data: string[]) => {
    const files = data.map((file, index) => ({
      label: `Estimate Approval Doc ${index + 1}`,
      path: file,
    }));

    setEstimateApprovalDocs((prev: any) => [...files]);
  };

  return (
    <>
      {[
        userStatus.ESTIMATE_APPROVAL_REQUEST,
        userStatus.ESTIMATE_APPROVED,
      ].includes(selectedStatus) &&
        [...ESTIMATE_APPROVAL_ARRAY, userStatus.ESTIMATE_QUERY_RAISED].includes(
          patient.status
        ) &&
        [userRoles.STAFF, userRoles.SUPER_ADMIN].includes(role) && (
          <div className="mg-y-16">
            <label className="form-label">Estimate Approval*</label>
            <BillUploadButton
              name="estimateDocuments"
              callBack={handleUpload}
              documentTitle="Documents"
            />
          </div>
        )}
    </>
  );
};

export default EstimateApproval;
